import React, { useState, useEffect, useRef } from 'react';
import DraggablePane from './DraggablePane';

const PaneManager = ({ children, panes = [] }) => {
  const [focusedPaneId, setFocusedPaneId] = useState(null);
  const [panePositions, setPanePositions] = useState({});
  const [paneSizes, setPaneSizes] = useState({});
  const initializedPanes = useRef(new Set());

  // Initialize pane positions and sizes only once per pane
  useEffect(() => {
    panes.forEach((pane, index) => {
      const id = pane.id;
      
      // Only initialize if this pane hasn't been initialized before
      if (!initializedPanes.current.has(id)) {
        initializedPanes.current.add(id);
        
        setPanePositions(prev => ({
          ...prev,
          [id]: pane.initialPosition || { 
            x: 50 + (index * 30), 
            y: 50 + (index * 30) 
          }
        }));
        
        setPaneSizes(prev => ({
          ...prev,
          [id]: pane.initialSize || { 
            width: 400, 
            height: 600 
          }
        }));
      }
    });
    
    // Set first pane as focused by default if no pane is focused
    if (panes.length > 0 && !focusedPaneId) {
      setFocusedPaneId(panes[0].id);
    }
  }, [panes, focusedPaneId]);

  const handlePaneFocus = (paneId) => {
    setFocusedPaneId(paneId);
  };

  const handlePanePositionChange = (paneId, newPosition) => {
    setPanePositions(prev => ({
      ...prev,
      [paneId]: newPosition
    }));
  };

  const handlePaneSizeChange = (paneId, newSize) => {
    setPaneSizes(prev => ({
      ...prev,
      [paneId]: newSize
    }));
  };

  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden' }}>
      {panes.map((pane, index) => (
        <DraggablePane
          key={pane.id}
          id={pane.id}
          initialPosition={panePositions[pane.id]}
          initialSize={paneSizes[pane.id]}
          minSize={pane.minSize || { width: 300, height: 400 }}
          onFocus={handlePaneFocus}
          onPositionChange={handlePanePositionChange}
          onSizeChange={handlePaneSizeChange}
          isFocused={focusedPaneId === pane.id}
          zIndex={index + 1}
        >
          {pane.component}
        </DraggablePane>
      ))}
      {children}
    </div>
  );
};

export default PaneManager; 